import React from 'react';
import { MenuItem, Link } from '@mui/material';
import { AccessibleEntity, Entity } from './types';
import { removeCookie } from './utils/removeCookie';
import { MultiOrgCookies, WorkingOrgCookie } from './hooks/useMultiOrgCookies';

interface EntityPickerListProps {
  entities: AccessibleEntity[] | Entity[];
}

export const EntityPickerList = ({ entities }: EntityPickerListProps) => {
  const handleLinkClick = () => {
    // Clear multi-org cookies before switching to another entity
    removeCookie(MultiOrgCookies);
    removeCookie(WorkingOrgCookie);
  };

  return (
    <div style={{ padding: '4px 0' }}>
      {entities.map((entity) => (
        <MenuItem key={entity?.id} dense disabled={!entity?.targetUrl}>
          {entity.targetUrl ? (
            <Link href={entity?.targetUrl} onClick={handleLinkClick}>
              {entity?.displayName || entity?.name}
            </Link>
          ) : (
            <>{entity?.displayName || entity?.name}</>
          )}
        </MenuItem>
      ))}
    </div>
  );
};
